// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown--1mmEBE","items":"items--3XX0fZ","show":"show--DDVSaV"};